class LoggerRun {

    public static $inject: string[] = [
        "$rootScope",
        "authService",
        "io",
        "loggerService"
    ];

    private sendLogs;

    constructor(
        $rootScope,
        authService,
        io,
        loggerService
    ) {
        this.sendLogs = () => {
            while (loggerService.logsStack.length > 0 && io.isOpen()) {
                const log = loggerService.logsStack.shift();
                log.user = {
                    organizationId: authService.getOrganizationId(),
                    role: authService.getRole(),
                    device: authService.getDevice(),
                    deviceId: authService.getDeviceId(),
                    firstname: authService.getFirstName(),
                    lastname: authService.getLastName()
                };
                io.send("pushLog", log);
            }
        };

        $rootScope.$watchCollection(
            () => {
                return loggerService.logsStack;
            },
            logsStack => {
                loggerService.save();

                if (logsStack.length > 0 ) {
                    this.sendLogs();
                }
            }
        );
    }
}

angular
    .module("thor.core.logger.run", [])
    .run(LoggerRun);
